import { authMutationService } from "./authMutationService";
import { authQueryService } from "./authQueryService";
import { authPasswordService } from "./authPasswordService";

import { authAppleService } from "./authAppleService";
import { authGoogleService } from "./authGoogleService";

/**
 * Main authentication service that combines all auth operations
 */
export const authService = {
  // Mutation operations
  signUp: authMutationService.signUp,
  signIn: authMutationService.signIn,
  signOut: authMutationService.signOut,
  
  // Query operations
  cleanupAuthState: authQueryService.cleanupAuthState,
  getCurrentUser: authQueryService.getCurrentUser,
  getUserProfile: authQueryService.getUserProfile,
  getCurrentUserFamilyId: authQueryService.getCurrentUserFamilyId,
  joinFamily: authQueryService.joinFamily,
  
  // Password operations
  sendPasswordReset: authPasswordService.sendPasswordReset,
  updatePassword: authPasswordService.updatePassword,

  // Apple operations
  signInWithApple: authAppleService.signInWithApple,
  signInWithAppleWeb: authAppleService.signInWithAppleWeb,

  // Google operations
  signInWithGoogle: authGoogleService.signInWithGoogle,
  handleGoogleAuthCallback: authGoogleService.handleGoogleAuthCallback,
};

// Export types from auth module for convenience
export type { SignUpData, SignInData, SignInResponse, SignUpResponse } from "@/types/auth";
